import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReportEditor from './ReportEditor';
import { fetchReportsTemplates } from 'redux/report/ReportActions';

const mapStateToProps = ({ reports }) => ({
  reportsTemplates: reports.reportsTemplates
});

const mapDispatchToProps = dispatch => ({
  reportsActions: bindActionCreators({ fetchReportsTemplates }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportEditor);



// WEBPACK FOOTER //
// ./src/components/manageReports/comp/reportEditor/ReportEditorConnector.js